import React from 'react'
import { ChatBreakoutSquare, CommandIcon, MessageChatCircle, MessageHeartIcon, MessageSmileCircle, Zap } from '../../../Icons'

const FeatureCard = ({ icon, title, detail }) => {
    return (
        <div className="flex flex-col gap-[20px] w-full items-center">
            <div className="flex items-center justify-center p-[12px] rounded-[10px] border-[1px] border-[#EAECF0] w-fit">
                {icon}
            </div>
            <div className="flex flex-col gap-[8px] items-center">
                <span className='text-[#101828] text-[20px] font-bold text-center'>
                    {title}
                </span>
                <p className='text-[16px] text-[#475467] text-center'>
                    {detail}
                </p>
            </div>
        </div>
    )
}

const FeatureSection = () => {
    return (
        <div className='flex flex-col py-[96px]  gap-[64px]  items-center max-2xl:px-[7.7vw] max-w-[1600px]'>
            <div className="flex flex-col gap-[20px] items-center max-w-[768px]">
                <div className="flex flex-col gap-[12px] items-center">
                    <span className='text-[#F02E49] font-[600] text-center'>
                        Features
                    </span>
                    <h2 className='text-[#101828] sm:text-[36px] text-[32px] font-[600] text-center'>
                        Elevate Your Performance: Exclusive Features for DJs
                    </h2>
                </div>
                <span className='text-[#475467] sm:text-[20px] text-[16px] text-center'>
                    Master Your Craft: All the Tools to Advance Your DJ Journey.
                </span>
            </div>
            <div className="grid lg:grid-cols-3 gap-[32px] md:grid-cols-2 grid-cols-1">
                <FeatureCard icon={<MessageSmileCircle iconColor={'#344054'} />} title={'Your Tour, Streamlined'} detail={'Organize your tours with precision. Our planner helps you manage dates, venues, and travel, keeping your focus on the music.'} />
                <FeatureCard icon={<Zap className={''} iconColor={'#344054'} />} title={'Land Your Next Big Event'} detail={'Discover and secure gigs with ease. Our intuitive platform connects you with venues and events looking for your unique sound.'} />
                <FeatureCard icon={<MessageHeartIcon iconColor={'#344054'} />} title={'Network with Fellow DJs'} detail={'Join a vibrant community of artists. Share experiences, collaborate on projects, and build lasting connections in the DJ world with our industry leading chat system.'} />
                <FeatureCard icon={<MessageChatCircle iconColor={'#344054'} />} title={'Exclusive Deals at Your Fingertips'} detail={'Unlock Exclusive Offers Instantly Discover a range of exclusive offers designed to enhance your DJ career. Access special discounts and more with just a tap.'} />
                <FeatureCard icon={<ChatBreakoutSquare className={'!w-[24px] !h-[24px]'} iconColor={'#344054'} />} title={' Live Analytics & Invoicing'} detail={'Empower your DJ business with real-time analytics and live invoicing. Track your gigs’ success and manage payments seamlessly, all in one place.'} />
                <FeatureCard icon={<CommandIcon iconColor={'#344054'} />} title={' Customizable DJ Profiles'} detail={'Showcase your unique style with a customizable profile. Highlight your best mixes, gigs, bio and reviews to attract new clients.'} />
            </div>
        </div>
    )
}

export default FeatureSection